import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AppSubscriptionContextType {
  refreshTrigger: number;
  triggerRefresh: () => void;
}

const AppSubscriptionContext = createContext<AppSubscriptionContextType | undefined>(undefined);

interface AppSubscriptionProviderProps {
  children: ReactNode;
}

export const AppSubscriptionProvider: React.FC<AppSubscriptionProviderProps> = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <AppSubscriptionContext.Provider value={{ refreshTrigger, triggerRefresh }}>
      {children}
    </AppSubscriptionContext.Provider>
  );
};

export const useAppSubscription = () => {
  const context = useContext(AppSubscriptionContext);
  if (context === undefined) {
    throw new Error('useAppSubscription must be used within an AppSubscriptionProvider');
  }
  return context;
};
